export default class SelectorModel {
  constructor(id, value, aux, aux2) {
    this.id = id;
    this.value = value;
    this.aux = aux;
    this.aux2 = aux2;
  }
}
